import { Template } from '@bynder-studio/render-core';
import { ImportTargetDpi } from 'packages/store/importTemplate/types';
import { gatewayClient, createService } from './connectors/httpClient';

export enum RequestTypes {
    ANALYSIS = 'ANALYSIS',
    IMPORT = 'IMPORT',
}

type CreateTemplateAnalysisBaseData = {
    type: RequestTypes.ANALYSIS;
    customerId: number;
    creatorId: string;
};

type CreateTemplateImportBaseData = {
    type: RequestTypes.IMPORT;
    customerId: number;
    collectionId: string;
    creatorId: string;
    multiDesignMode: boolean;
    indesignImportPropertiesDto?: {
        targetDpi: ImportTargetDpi;
    };
};

type CreateTemplateAnalysisGlobalData = CreateTemplateAnalysisBaseData & {
    mediaId: string;
};

type CreateTemplateImportGlobalData = CreateTemplateImportBaseData & {
    mediaId: string;
};

type CreateTemplateAnalysisLocalData = CreateTemplateAnalysisBaseData & {
    storagePath: string;
};

type CreateTemplateImportLocalData = CreateTemplateImportBaseData & {
    storagePath: string;
};

type CreateTemplateFigmaData = CreateTemplateImportBaseData & {
    figmaImportPropertiesDto: {
        fileKey: string;
        frameIds: string[];
    };
};

export type CreateTemplateData =
    | CreateTemplateAnalysisGlobalData
    | CreateTemplateAnalysisLocalData
    | CreateTemplateImportGlobalData
    | CreateTemplateImportLocalData
    | CreateTemplateFigmaData;

const httpClient = gatewayClient('/design-creation-requests');

const templatesServiceFromDesignFile = createService(httpClient, (client) => ({
    createTemplate(data: CreateTemplateData) {
        return client.post<Template>('', data);
    },
}));

export default templatesServiceFromDesignFile;
